import * as React from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", props, /* @__PURE__ */ React.createElement("path", { d: "M32.073 17.074a3.44 3.44 0 0 1 1.644 2.929c0 1.193-.622 2.3-1.644 2.864L11.501 35.441a3.296 3.296 0 0 1-3.466.129 3.43 3.43 0 0 1-1.752-2.994V7.43a3.43 3.43 0 0 1 5.218-2.926l20.572 12.57Z" }));
export default SvgPlay;
